import { FC } from "react";

import { OrganizationLogoAndName } from "@/canvas/components/OrganizationLogoAndName/OrganizationLogoAndName";
import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { usePreviewContext } from "@/features/LiveFormEditor/LivePreview/contexts/PreviewContext";

export const CampaignOrgChip: FC = () => {
  const { isPreview, placeholders } = usePreviewContext();
  const { publishedOrgPageUrl, formObject } = useFormV2Context();

  return (
    <OrganizationLogoAndName
      name={formObject.organization?.name ?? ""}
      logoSrc={formObject.logoUrl ?? undefined}
      withFallbackImage={isPreview && placeholders.isLogo}
      publishedOrgPageUrl={publishedOrgPageUrl}
      isVerified={formObject.verifiedBadgeVariant === "badge"}
    />
  );
};
